'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardGraphBuilderCtrl', require('./dashboardGraphBuilderCtrl'));
app.factory('graphFactory', ['Department','$translate', require('./graphFactory')]);

app.directive('graphElement', [require('./graphElementDirective')]);
app.directive('graphElementConfig', [require('./graphConfigDirective')]);
app.directive('datasource', [require('./dataSourceDirective')]);
app.directive('datasourceElement', [require('./dataSourceElementDirective')]);
app.directive('datasourceGroupel', [require('./dataSourceGroupElDirective')]);
app.directive('datasourceSimplelistel', [require('./dataSourceSimplelistElDirective')]);
app.directive('datasourceSimplelistel2', [require('./dataSourceSimplelistElDirective2')]);
app.directive('textjson', [require('./textJsonDirective')]);
app.directive('inputSelectFlattenedForms', [require('../directives/inputSelectFlattenedFormsDirective')]);
app.directive('datasourceIntegrationElement', [require('./dataSourceIntegrationElementDirective')]);
app.directive('options4', [require('./options4Directive')]);

/* 
app.directive('subElement', [require('./subElementDirective')]);
app.directive('subElement2', [require('./subElement2Directive')]);

app.directive('selectOptions', [require('./select-element/selectOptions')]);
app.directive('options', [require('./optionsDirective')]);

app.directive('elementConfig', [require('./configDirective')]);

app.directive('formula', [require('./formulaDirective')]);
app.directive('duration', [require('./durationDirective')]);

app.directive('simpleList', [require('./simpleListDirective')]);


app.factory('BuilderDataService', require('./builderDataService'));
 
app.directive('advancedConfig', [require('./advancedConfig/advancedConfigDirective')]);
app.directive('dinamicConfig', [require('./dinamic-select-config/dinamicSelectConfig')]);

app.directive('requiredGraph', [require('./conditions-graph/requiredGraphDirective')]);

app.directive('integration', [require('./integrationDirective')]);
*/

app.config(['$stateProvider', require('./dashboardGraphBuilderConfig')]);
